import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ZitiWasmService, ZitiConnectionState, overallConnectionStatus } from '../ziti-wasm.service';

@Component({
    selector: 'lib-ziti-status-indicator',
    templateUrl: './ziti-status-indicator.component.html',
    styleUrls: ['./ziti-status-indicator.component.scss'],
    standalone: false,
})
export class ZitiStatusIndicatorComponent implements OnDestroy {
    state: ZitiConnectionState = { controller: 'disconnected', controllerUrl: '', edgeRouters: [] };
    metricsOpen = false;
    private subscription = new Subscription();

    constructor(private zitiWasmService: ZitiWasmService) {
        this.subscription.add(
            this.zitiWasmService.connectionState$.subscribe((s) => {
                this.state = s;
            })
        );
        this.subscription.add(
            this.zitiWasmService.metricsPanelOpen$.subscribe((open) => {
                this.metricsOpen = open;
            })
        );
    }

    get overallStatus(): string {
        return overallConnectionStatus(this.state);
    }

    get statusLabel(): string {
        switch (this.overallStatus) {
            case 'connected': return 'Connected';
            case 'error': return 'Unavailable';
            case 'connecting': return 'Connecting';
            default: return 'Offline';
        }
    }

    get badgeTone(): string {
        switch (this.overallStatus) {
            case 'connected': return 'nf-badge--ok';
            case 'error': return 'nf-badge--err';
            case 'connecting': return 'nf-badge--warn';
            default: return 'nf-badge--muted';
        }
    }

    get tooltip(): string {
        const action = this.metricsOpen ? 'Hide secure connection metrics' : 'Show secure connection metrics';
        switch (this.overallStatus) {
            case 'connected': return `Connected to the network controller over Ziti. ${action}.`;
            case 'error': return `The secure connection is unavailable, so requests use a direct connection. ${action}.`;
            case 'connecting': return `Connecting to the network controller over Ziti. ${action}.`;
            default: return `The secure connection is not connected, so requests use a direct connection. ${action}.`;
        }
    }

    toggleMetricsPanel() {
        const current = this.zitiWasmService.metricsPanelOpen$.getValue();
        this.zitiWasmService.metricsPanelOpen$.next(!current);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
